module.exports = __webpack_public_path__ + "img/offtowork.0950f7ea.png";